import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Injector,
  INJECTOR,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {IntDefaultInputComponent} from "../int-default-input";

@Component({
  selector: 'int-password-input',
  templateUrl: './int-password-input.component.html',
  styleUrls: ['./int-password-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: IntPasswordInputComponent,
      multi: true
    }
  ]
})
export class IntPasswordInputComponent implements ControlValueAccessor {

  value$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>('');

  isFocused = false;

  @Input()
  appearance: 'text' | 'password' = 'password';

  @Input()
  placeholder = '';

  @Input()
  label = '';

  @Input()
  showLabelTip = true;

  @Input()
  readonly = false;

  @Input()
  autocomplete: string | null = null;

  @Input()
  hideField: boolean = false;

  @Input()
  name: string | null = null;

  @Output() change = new EventEmitter<string>();

  @ViewChild(IntDefaultInputComponent) private readonly inputElement!: IntDefaultInputComponent;

  get iconName(): 'eye' | 'eye-slash' {
    return this.appearance === 'text' ? 'eye' : 'eye-slash';
  }

  writeValue(value: string) {
    this.value$.next(value);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  onChange(value: string) {
    this.change.emit(value);
  }

  onTouched() {}

  setPseudoFocus() {
    this.inputElement?.setPseudoFocus();
  }

  setBlur() {
    this.inputElement?.setBlur();
  }

  onBlur() {
    this.onTouched();
    this.isFocused = false;
  }

  onFocus() {
    this.isFocused = true;
  }

  changeAppearance(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.appearance = this.appearance === 'text' ? 'password' : 'text';
  }
}
